import React, { useContext, useEffect, useState, } from 'react';
// import { FaArrowRightLong } from "react-icons/fa6";
import { FormContext } from '../Provider';
import { useNavigate } from 'react-router-dom';
// import { useParams } from 'react-router-dom';

export default function EditRegister({ step, setStep, id }) {
    console.log("step:", step, "setStep:", setStep); // Debug line
    const navigate = useNavigate()
    const { editPersonal, setEditPersonal, imagePre, setImagePre } = useContext(FormContext);
    const api = process.env.REACT_APP_URL;

    const [courses, setCourses] = useState(null)
    // Debug line

  useEffect(() => {
        fetch(`${api}/get-courses`,
            {
                method: 'GET',
                credentials: 'include'
            })
            .then(res => res.json())
            .then((data) => {
                if (data.success) {
                    setCourses(data.courses)
                    console.log(data)
                }
                else {
                    alert(data.message)
                }

            })

    }, [api])





    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Clean up previous preview if exists
            if (imagePre) {
                URL.revokeObjectURL(imagePre);
            }

            // Create new preview
            const preview = URL.createObjectURL(file);

            setEditPersonal(prev => ({
                ...prev,
                registration: {
                    ...prev.registration,
                    signature: file
                }
            }));


            // Set new preview
            setImagePre(preview);
        }
    }
    // Revoke object URL on cleanup
    // Cleanup function for image preview



    // Cleanup when component unmounts




    const handleSubmit = (e) => {
        e.preventDefault();
        // if (imagePreview) {
        //     URL.revokeObjectURL(imagePreview);
        //     setImagePreview(null);
        // }

        const formDatas = new FormData();
        // Personal Information Details
        formDatas.append('name', editPersonal.personalData.name);
        formDatas.append('dob', editPersonal.personalData.dob);
        formDatas.append('guardianName', editPersonal.personalData.guardianName);
        formDatas.append('gender', editPersonal.personalData.gender);
        formDatas.append('address', editPersonal.personalData.address);
        formDatas.append('contact', editPersonal.personalData.contact);
        formDatas.append('alternateNumber', editPersonal.personalData.alternateNumber);
        formDatas.append('email', editPersonal.personalData.email);
        formDatas.append('pincode', editPersonal.personalData.pincode);
        formDatas.append('emergencyContact', editPersonal.personalData.emergencyContact);
        formDatas.append('proof', editPersonal.personalData.proof);
        formDatas.append('proofImage', editPersonal.personalData.proofImage);
        formDatas.append('profilePic', editPersonal.personalData.profilePic);


        // Academic Information Details
        formDatas.append('instituteName', editPersonal.academicDetails.instituteName);
        formDatas.append('courseName', editPersonal.academicDetails.courseName);
        formDatas.append('deptName', editPersonal.academicDetails.deptName);
        formDatas.append('isGoing', editPersonal.academicDetails.isGoing);
        formDatas.append('passout', editPersonal.academicDetails.passout);
        formDatas.append('location', editPersonal.academicDetails.location);

        // Employment Information Details
        formDatas.append('companyName', editPersonal.employmentInfo.companyName);
        formDatas.append('designation', editPersonal.employmentInfo.designation);
        formDatas.append('exp', editPersonal.employmentInfo.exp);
        formDatas.append('companyLocation', editPersonal.employmentInfo.companyLocation);
        formDatas.append('JoinedDate', editPersonal.employmentInfo.JoinedDate);
        formDatas.append('EndDate', editPersonal.employmentInfo.EndDate);
        formDatas.append('isactive', editPersonal.employmentInfo.isactive);

        // Register Information Details
        formDatas.append('registerDate', editPersonal.registration.registerDate);
        formDatas.append('course', editPersonal.registration.course);
        formDatas.append('batchStart', editPersonal.registration.batchStart);
        formDatas.append('batchEnd', editPersonal.registration.batchEnd);
        formDatas.append('type', editPersonal.registration.aboutUs.type);
        formDatas.append('extraInfo', editPersonal.registration.aboutUs.extraInfo);
        formDatas.append('feeMethod', editPersonal.registration.feeMethod);
        formDatas.append('signature', editPersonal.registration.signature)


        // const payload = {
        //     // Personal Information
        //     name: editPersonal.personalData.name,
        //     dob: editPersonal.personalData.dob,
        //     guardianName: editPersonal.personalData.guardianName,
        //     gender: editPersonal.personalData.gender,
        //     address: editPersonal.personalData.address,
        //     contact: editPersonal.personalData.contact,
        //     alternateNumber: editPersonal.personalData.alternateNumber,
        //     email: editPersonal.personalData.email,
        //     pincode: editPersonal.personalData.pincode,
        //     emergencyContact: editPersonal.personalData.emergencyContact,
        //     proof: editPersonal.personalData.proof,

        //     // Academic Information
        //     instituteName: editPersonal.academicDetails.instituteName,
        //     courseName: editPersonal.academicDetails.courseName,
        //     deptName: editPersonal.academicDetails.deptName,

        //     passout: editPersonal.academicDetails.passout,
        //     location: editPersonal.academicDetails.location,

        //     // Employment Information
        //     companyName: editPersonal.employmentInfo.companyName,
        //     designation: editPersonal.employmentInfo.designation,
        //     exp: editPersonal.employmentInfo.exp,
        //     companyLocation: editPersonal.employmentInfo.companyLocation,
        //     JoinedDate: editPersonal.employmentInfo.JoinedDate,
        //     EndDate: editPersonal.employmentInfo.EndDate,
        //     isactive: editPersonal.employmentInfo.isactive,

        //     // Registration Information
        //     registerDate: editPersonal.registration.registerDate,
        //     course: editPersonal.registration.course,
        //     batchStart: editPersonal.registration.batchStart,
        //     batchEnd: editPersonal.registration.batchEnd,
        //     type: editPersonal.registration.aboutUs.type,
        //     extraInfo: editPersonal.registration.aboutUs.extraInfo,
        //     feeMethod: editPersonal.registration.feeMethod,
        // };


        console.log("ID", id);

        fetch(`${api}/update-details/${id}`, {
            method: 'POST',
            credentials: 'include',

            body: formDatas,

        })
            .then(res => res.json())
            .then(data => {

                if (data.success === true) {
                    alert("Upload Data Successfully");
                    navigate('/admin/dashboard');
                }
                else {
                    alert(data.message);
                }
            })
            .catch(err => {
                console.log("error in fetch user register", err);
                alert("Trouble in Registration, Please try again later");
            })
    };

    return (
        <section className="bg-white rounded-lg shadow-md p-7">

            <div className=' bg-gray-100 px-4 container py-5 h-100 flex justify-center items-start'>
                <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                    <div className="font-bold text-lg text-primary-800">Registration Details</div>

                    <form onSubmit={handleSubmit}>
                        {/* First and Last Name */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 mt-8">
                            <div className="relative">
                                <input
                                    type="date"
                                    id="registrationDate"
                                    value={editPersonal.registration.registerDate ? new Date(editPersonal.registration.registerDate).toISOString().split('T')[0] : ''}
                                    onChange={(e) => setEditPersonal(prev => ({
                                        ...prev,
                                        registration: {
                                            ...prev.registration,
                                            registerDate: e.target.value
                                        }
                                    }))}
                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    placeholder=" "
                                    required
                                />
                                <label
                                    htmlFor="registrationDate"
                                    className="absolute text-base font-medium text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3 "

                                >
                                    Registration Date
                                </label>

                            </div>
                            <div className="relative w-full">
                                <select
                                    id="courseName"
                                    value={editPersonal.registration.course}
                                    onChange={(e) => setEditPersonal(prev => ({
                                        ...prev,
                                        registration: {
                                            ...prev.registration,
                                            course: e.target.value
                                        }
                                    }))}
                                    className="block w-full px-2.5 pb-2.5 pt-4 text-xs sm:text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer truncate"
                                    required
                                >
                                    <option value="" disabled>Select Course</option>
                                    {courses && courses.map(course => (
                                        <option key={course.id} value={course.courseTitle}>{course.courseTitle}</option>
                                    ))}
                                </select>

                                {/* Error */}


                                {/* Arrow */}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                        clipRule="evenodd"
                                    />
                                </svg>

                                {/* Label */}
                                <label
                                    htmlFor="courseName"
                                    className="absolute text-base font-medium text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-3"
                                >
                                    Course Name
                                </label>
                            </div>



                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 items-center">
                            <div className="relative">
                                <input
                                    type="date"
                                    id="batchStartDate"
                                    value={editPersonal.registration.batchStart ? editPersonal.registration.batchStart.split('T')[0] : ''}
                                    onChange={(e) => setEditPersonal(prev => ({
                                        ...prev,
                                        registration: {
                                            ...prev.registration,

                                            batchStart: e.target.value
                                        }
                                    }))}
                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    placeholder=" "
                                    required
                                />
                                <label
                                    htmlFor="batchStartDate"
                                    className="absolute text-base font-medium text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3 "
                                >
                                    Batch Start Date
                                </label>

                            </div>
                            <div className="relative">
                                <input
                                    type="date"
                                    id="batchEndDate"
                                    value={editPersonal.registration.batchEnd ? editPersonal.registration.batchEnd.split('T')[0] : ''}
                                    onChange={(e) => setEditPersonal(prev => ({
                                        ...prev,

                                        registration: {
                                            ...prev.registration,
                                            batchEnd: e.target.value
                                        }
                                    }))}

                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    placeholder=" "
                                    required
                                />
                                <label
                                    htmlFor="batchEndDate"
                                    className="absolute text-base font-medium text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3 "
                                >
                                    Batch End Date
                                </label>

                            </div>
                        </div>

                        {/* Email and Phone */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div className="mb-4">
                                <div className="relative">
                                    <select
                                        id="hearAboutUs"
                                        value={editPersonal.registration.aboutUs.type}
                                        onChange={(e) => setEditPersonal(prev => ({
                                            ...prev,
                                            registration: {
                                                ...prev.registration,
                                                aboutUs: {
                                                    ...prev.registration.aboutUs,
                                                    type: e.target.value
                                                }
                                            }
                                        }))}
                                        className="block w-full px-2.5 pb-2.5 pt-4 text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        required
                                    >
                                        <option value="" disabled>
                                            Select Option
                                        </option>
                                        <option value="Social Media">Social Media</option>
                                        <option value="Seminar">Seminar</option>
                                        <option value="Friend">Friend</option>
                                        <option value="Ex-Student">Ex-Student</option>
                                        <option value="Others">Others</option>
                                    </select>



                                    {/* Label */}
                                    <label
                                        htmlFor="hearAboutUs"
                                        className="absolute text-base font-medium text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3"
                                    >
                                        <span className='hidden md:block'>How Did You Hear About Us?</span>
                                        <span className='block md:hidden'>How Did You Hear Us?</span>
                                    </label>

                                    {/* Dropdown icon */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div>

                                {/* Show this only if "Friend" is selected */}
                                {(editPersonal.registration.aboutUs.type === "Friend" || editPersonal.registration.aboutUs.type === "Others") && (
                                    <div className="mt-4">
                                        <label htmlFor="reasons" className="block text-sm font-medium text-gray-700 mb-1">
                                            Friend's Name / Others
                                        </label>
                                        <input
                                            type="text"
                                            id="reasons"
                                            value={editPersonal.registration.aboutUs.extraInfo}
                                            onChange={(e) => setEditPersonal(prev => ({
                                                ...prev,
                                                registration: {
                                                    ...prev.registration,
                                                    aboutUs: {
                                                        ...prev.registration.aboutUs,
                                                        extraInfo: e.target.value
                                                    }
                                                }
                                            }))}

                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            placeholder="Enter your friend's name / Others"
                                            required
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Payment Method */}

                            <div className="mb-4">
                                <div className="relative">
                                    <select
                                        id="feeMethod"
                                        value={editPersonal.registration.feeMethod}
                                        onChange={(e) => setEditPersonal(prev => ({
                                            ...prev,
                                            registration: {
                                                ...prev.registration,
                                                feeMethod: e.target.value
                                            }
                                        }))}
                                        className="block w-full px-2.5 pb-2.5 pt-4 text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        required
                                    >
                                        <option value="" disabled>
                                            Select Payment Method
                                        </option>
                                        {/* <option value="Fresh Registration">Fresh Registration</option> */}
                                        <option value="Installment">Installment</option>
                                        <option value="Full Payment">Full Payment</option>
                                        {/* <option value="Upgradation">Upgradation</option> */}
                                    </select>

                                    {/* Dropdown arrow icon */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    <label htmlFor="floating_outlined" className="absolute text-base font-medium text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-3"> Fee Method </label>
                                </div>

                            </div>
                        </div>

                        {/* Subject Select */}
                        <label className='font-medium mb-3'>Upload Signature:</label>
                        <div className="flex items-center justify-start w-full h-full">

                            <label
                                htmlFor="dropzone-fileee"
                                className={`flex flex-col items-center justify-center w-full h-44 cursor-pointer  `}
                            >
                                {/* 👇 Conditional Preview or Default SVG Instructions */}

                                <div className="flex items-center justify-start w-full h-full">
                                    {
                                        imagePre ? (
                                            <img
                                                src={imagePre}
                                                alt="Preview"
                                                className="h-full object-contain border-2 border-gray-300 border-dashed rounded-lg"
                                            />
                                        ) :

                                            (editPersonal?.registration?.signature?.filename ? (
                                                <img
                                                    src={`${api}/upload/${editPersonal.registration.signature.filename}`}
                                                    alt={editPersonal.registration.signature.filename}
                                                    className="h-full object-contain border-2 border-gray-300 border-dashed rounded-lg"
                                                />


                                            ) : (
                                                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                    <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                    </svg>
                                                    <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                                                    <p className="text-xs text-gray-500">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
                                                </div>
                                            ))
                                    }
                                </div>

                                <input
                                    id="dropzone-fileee"
                                    type="file"
                                    className="hidden"
                                    onChange={handleFileChange}
                                    required
                                />
                            </label>
                        </div>



                        {/* Submit Button */}
                        <div className="flex flex-row sm:flex-row justify-between items-stretch sm:items-center gap-4 mt-6">
                            {/* Previous Button */}
                            <div className="w-full sm:w-auto">
                                <button
                                    type="button"
                                    className="w-full  px-6 py-2 flex items-center justify-center bg-primary-800 hover:bg-primary-700 text-white text-base font-medium rounded-lg  transition"
                                    onClick={() => {
                                        navigate(`/admin-forms/${id}`)
                                        setStep(step - 1)
                                    }} >
                                    {/* <FaArrowLeftLong className="mx-2" />  */}
                                    Back
                                </button>
                            </div>

                            {/* Next Button */}
                            <div className="w-full sm:w-auto">
                                <button
                                    type="submit"
                                    onClick={handleSubmit}
                                    className="w-full  px-6 py-2 flex items-center justify-center bg-green-400 hover:bg-green-600 text-white text-base font-medium rounded-lg transition"
                                >
                                    Update
                                    {/* <FaArrowRight className="ms-3" /> */}
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </section>

    );
}


